import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import React, { FC, useContext } from "react";
import { RoomAssignmentViewModel } from "../../model/RoomAssignmentViewModel";
import { TimeSlot } from "../../model/TimeSlotStructure";
import { getTimeSlotLabel } from "../../utils/TimeSlotUtils";
import { SchedulerContextValue } from "./context/SchedulerContext";
import SchedulerCell from "./SchedulerCell";

interface SchedulerTimeSlotRowProps {
  timeSlot: TimeSlot;
}

const SchedulerTimeSlotRow: FC<SchedulerTimeSlotRowProps> = ({ timeSlot }) => {
  const { selectedExamDayId, rooms, examDays, renderCell, renderTimeSlotLabel } = useContext(SchedulerContextValue);

  const getRoomAssignment = (roomId: string) => {
    const examDay = examDays.find((examDay) => examDay.id === selectedExamDayId);
    return examDay?.roomAssignments.find((roomAssignment) => roomAssignment.roomId === roomId);
  };

  const getRoomExamIds = (roomAssignment: RoomAssignmentViewModel | undefined) => {
    if (timeSlot.index === undefined || roomAssignment === undefined) {
      return [];
    }

    return roomAssignment.examAssignments
      .filter((examAssignment) => examAssignment.timeSlotIndex === timeSlot.index)
      .map((examAssignment) => examAssignment.examId);
  };

  const label = getTimeSlotLabel(timeSlot);
  return (
    <TableRow key={label}>
      <TableCell>{renderTimeSlotLabel !== undefined ? renderTimeSlotLabel(timeSlot) : label}</TableCell>
      {rooms.map((room) => {
        const roomAssignment = getRoomAssignment(room.id);
        const examIds = getRoomExamIds(roomAssignment);
        if (renderCell !== undefined) {
          return renderCell(examIds, room, timeSlot.index!, room.id);
        }

        if (roomAssignment?.isPreparationRoom) {
          return <TableCell key={room.id} />;
        }

        return <SchedulerCell key={room.id} examIds={examIds} room={room} timeSlotIndex={timeSlot.index!} />;
      })}
    </TableRow>
  );
};

export default SchedulerTimeSlotRow;
